import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useAppDispatch from "hooks/useAppDispatch";
import { login } from "../../../../redux/features/auth/authSlice";
import { handlePostLoginRedirect } from "../utils/authRedirect";

export default function useLogInAdminPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loggingIn = useSelector((state) => state.auth.loggingInLoading);

  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [password, setPassword] = useState("");
  const [errorPassword, setErrorPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const validateLogin = useCallback((value) => {
    if (value.length === 0) {
      setErrorEmail("Enter your login");
    } else {
      setErrorEmail(false);
    }
  }, []);

  const togglePasswordVisibility = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const doLogin = useCallback(async () => {
    if (!password) {
      setErrorPassword("Please enter your password and login");
      return;
    }

    try {
      const res = await dispatch(login({ email, password }));
      if (res?.error) {
        setErrorPassword("Email or password is incorrect");
        return;
      }
      handlePostLoginRedirect(res, navigate);
    } catch {
      setErrorPassword("Email or password is incorrect");
    }
  }, [dispatch, email, password, navigate]);

  const handlePasswordChange = useCallback((value) => {
    setPassword(value);
    setErrorPassword(false);
  }, []);

  return {
    t,
    loggingIn,
    email,
    errorEmail,
    password,
    errorPassword,
    showPassword,
    setEmail,
    validateLogin,
    togglePasswordVisibility,
    handlePasswordChange,
    doLogin,
  };
}
